import { Injectable } from '@angular/core';
import { DictionaryService } from '@app/core/services/dictionary.service';
import { DictionaryRestService } from '@app/pcs/services/dictionary-rest.service';
import * as R from 'ramda';
import { Observable, of } from 'rxjs';
import { filter, switchMap, tap } from 'rxjs/operators';


@Injectable()
export class DictionaryGuard  {

  constructor(private dictionaryService: DictionaryService,
    private dictionaryRestService: DictionaryRestService) {
  }

  canActivate(): Observable<boolean> {
    if (R.isNil(this.dictionaryService.getDictionaries())) {
      return this.dictionaryRestService.fetchDictionaries()
        .pipe(
          filter(dictionaries => !R.isNil(dictionaries)),
          tap(dictionaries => this.dictionaryService.setDictionaries(dictionaries)),
          switchMap(() => of(true))
        );
    }
    return of(true);
  }

}
